import { useServiceContext } from "../../../../contexts/ServiceContext";
import React, { useEffect, useRef, useState } from "react";
import { ScreenHeader } from "../../../components/structure/ScreenHeader";
import { useAuthenticationContext } from "../../../../contexts/UserContext";
import { Template, TemplateType } from "../../../../core/entities/template";
import { ContentBox } from "../../../components/structure/ContentBox";
import { ContentHeader } from "../../../components/structure/ContentHeader";
import { TemplatePdfView } from "../TemplateOverview/subcomponents/TemplatePdfView";
import { RoundedIconButton } from "../../../components/buttons/RoundedIconButton";
import { ReactComponent as Expand } from "../../../../resources/icons/expand.svg";
import { ReactComponent as Reduce } from "../../../../resources/icons/reduce.svg";
import { TemplateTypeDisplay } from "../../../../core/entities/templateTypeDisplay";
import { PageUnknownErrorErrorScreen } from "../../public/ErrorPage/ErrorPage.Screen";
import { LoadingBoxFillComponent } from "../../../components/state/Loading";

export function TemplatePreviewScreen() {
    const { user } = useAuthenticationContext();
    const {
        templateService: { getPublishedWithReplacedFields, getTypes }
    } = useServiceContext();

    const [publishedTemplates, setPublishedTemplates] = useState<
        Map<TemplateType, Template>
    >(new Map());

    const [dimensions, setDimensions] = useState<{
        height: number;
        width: number;
    }>();

    const [types, setTypes] = useState<TemplateTypeDisplay[]>();
    const [selectedType, setSelectedType] = useState<TemplateType>();
    const [error, setError] = useState<any>();
    const isLoading = !types || publishedTemplates.size === 0;

    useEffect(() => {
        getPublishedWithReplacedFields()
            .then((x) => {
                const map = new Map<TemplateType, Template>();
                const types: TemplateType[] = [];
                for (const template of x) {
                    map.set(template.type, template);
                    types.push(template.type);
                }
                setPublishedTemplates(map);
                setSelectedType(x[0].type);
            })
            .catch(setError);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        getTypes()
            .then((x) => {
                setTypes(x);
            })
            .catch(setError);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const ref = useRef<HTMLDivElement>(null);

    let selectedTemplate;
    if (selectedType) {
        selectedTemplate = publishedTemplates.get(selectedType);
    }

    function expandView() {
        if (!ref.current) {
            return;
        }
        const width = ref.current.offsetWidth - 100;
        const height = width * 1.41;
        setDimensions({ width, height });
    }

    function reduceView() {
        setDimensions(undefined);
    }

    function selectType(type: TemplateType) {
        setSelectedType(type);
    }

    const core = (
        <ContentBox
            key={"core"}
            className={"animate-fade-in w-fit mb-0 min-h-[912px] min-w-[600px]"}
        >
            <div className={"flex justify-between items-center mb-20"}>
                <ContentHeader className={"text-center align-middle mb-0"}>
                    Preview
                </ContentHeader>
                <div className={"flex-1 flex justify-center gap-8"}>
                    {types?.map((x) => (
                        <div
                            key={x.key}
                            onClick={() => selectType(x.key)}
                            className={
                                "text-sx font-medium py-12 px-20 rounded-8 cursor-pointer " +
                                (selectedType === x.key
                                    ? "bg-secondary-blue-lightest"
                                    : "")
                            }
                        >
                            {x.displayValue}
                        </div>
                    ))}
                </div>
                <div>
                    <RoundedIconButton
                        onClick={() => {
                            if (dimensions) {
                                reduceView();
                            } else {
                                expandView();
                            }
                        }}
                    >
                        {dimensions ? <Reduce /> : <Expand />}
                    </RoundedIconButton>
                </div>
            </div>
            <div className={"flex justify-center items-center"}>
                {selectedTemplate ? (
                    <TemplatePdfView
                        selected={selectedTemplate!}
                        width={dimensions?.width}
                        height={dimensions?.height}
                    />
                ) : (
                    <div className={"mt-[100px]"}>Ingen skabelon</div>
                )}
            </div>
        </ContentBox>
    );

    return isLoading && !error ? (
        <LoadingBoxFillComponent />
    ) : error ? (
        <PageUnknownErrorErrorScreen />
    ) : (
        <>
            <ScreenHeader>{user?.companyName}</ScreenHeader>
            {!dimensions ? (
                <div
                    ref={ref}
                    className={
                        "bg-secondary-blue-light w-full p-40 flex justify-center rounded-16"
                    }
                >
                    {core}
                </div>
            ) : (
                <>{core}</>
            )}
        </>
    );
}
